export interface TreatmentService {
  id: string;
  titleKey: string;
  subtitleKey: string;
  descriptionKey: string;
  tagKey: string;
  tagColor: string;
  icon: string;
  image: string;
  color: string;
  bg: string;
  border: string;
  /**
   * Kurum services[] alanında tam eşleşecek değerler.
   * GeneralInfoSubTab'daki defaultServices listesiyle senkronize olmalı.
   */
  serviceKeys: string[];
}

export const treatmentServices: TreatmentService[] = [
  {
    id: 'sac-ekimi',
    titleKey: 'treat_sac_ekimi_title',
    subtitleKey: 'treat_sac_ekimi_subtitle',
    descriptionKey: 'treat_sac_ekimi_desc',
    tagKey: 'treat_sac_ekimi_tag',
    tagColor: 'bg-amber-500',
    icon: 'ri-scissors-2-line',
    image: 'https://public.readdy.ai/ai/img_res/77d075d6fdaf4af1f828c9a36f8d7945.jpg',
    color: 'from-amber-500 to-orange-500',
    bg: 'from-amber-50 to-orange-50',
    border: 'border-amber-100',
    serviceKeys: ['Saç Ekimi'],
  },
  {
    id: 'dis-tedavisi',
    titleKey: 'treat_dis_tedavisi_title',
    subtitleKey: 'treat_dis_tedavisi_subtitle',
    descriptionKey: 'treat_dis_tedavisi_desc',
    tagKey: 'treat_dis_tedavisi_tag',
    tagColor: 'bg-teal-500',
    icon: 'ri-tooth-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20with%20advanced%20equipment%2C%20dentist%20performing%20cosmetic%20dental%20procedure%2C%20bright%20white%20clinical%20environment%2C%20professional%20dental%20chair%20and%20tools%2C%20high-tech%20dental%20facility&width=600&height=400&seq=treat-dental-1&orientation=landscape',
    color: 'from-teal-500 to-emerald-500',
    bg: 'from-teal-50 to-emerald-50',
    border: 'border-teal-100',
    serviceKeys: ['Diş Tedavisi & İmplant', 'Diş Beyazlatma', 'Zirkonyum Kaplama'],
  },
  {
    id: 'goz-ameliyati',
    titleKey: 'treat_goz_ameliyati_title',
    subtitleKey: 'treat_goz_ameliyati_subtitle',
    descriptionKey: 'treat_goz_ameliyati_desc',
    tagKey: 'treat_goz_ameliyati_tag',
    tagColor: '',
    icon: 'ri-eye-line',
    image: 'https://readdy.ai/api/search-image?query=advanced%20ophthalmology%20clinic%20with%20laser%20eye%20surgery%20equipment%2C%20eye%20specialist%20examining%20patient%20with%20modern%20diagnostic%20tools%2C%20clean%20medical%20environment%20with%20blue%20and%20white%20tones%2C%20professional%20eye%20care%20facility&width=600&height=400&seq=treat-eye-1&orientation=landscape',
    color: 'from-sky-500 to-cyan-500',
    bg: 'from-sky-50 to-cyan-50',
    border: 'border-sky-100',
    serviceKeys: ['Göz Lazer (LASIK)', 'Katarakt Ameliyatı'],
  },
  {
    id: 'estetik-cerrahi',
    titleKey: 'treat_estetik_cerrahi_title',
    subtitleKey: 'treat_estetik_cerrahi_subtitle',
    descriptionKey: 'treat_estetik_cerrahi_desc',
    tagKey: 'treat_estetik_cerrahi_tag',
    tagColor: 'bg-rose-500',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20aesthetic%20surgery%20clinic%20with%20elegant%20interior%20design%2C%20professional%20plastic%20surgeon%20consultation%20room%2C%20modern%20medical%20facility%20with%20warm%20lighting%2C%20upscale%20healthcare%20environment&width=600&height=400&seq=treat-aesthetic-1&orientation=landscape',
    color: 'from-rose-500 to-pink-500',
    bg: 'from-rose-50 to-pink-50',
    border: 'border-rose-100',
    serviceKeys: ['Estetik Cerrahi', 'Burun Estetiği (Rinoplasti)'],
  },
  {
    id: 'ortopedi',
    titleKey: 'treat_ortopedi_title',
    subtitleKey: 'treat_ortopedi_subtitle',
    descriptionKey: 'treat_ortopedi_desc',
    tagKey: 'treat_ortopedi_tag',
    tagColor: '',
    icon: 'ri-walk-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20orthopedic%20surgery%20center%20with%20advanced%20robotic%20surgery%20equipment%2C%20orthopedic%20specialist%20examining%20knee%20joint%20model%2C%20professional%20medical%20facility%20with%20clean%20white%20environment&width=600&height=400&seq=treat-ortho-1&orientation=landscape',
    color: 'from-violet-500 to-purple-500',
    bg: 'from-violet-50 to-purple-50',
    border: 'border-violet-100',
    serviceKeys: ['Ortopedi & Eklem Cerrahisi', 'Diz & Kalça Protezi', 'Omurga Cerrahisi'],
  },
  {
    id: 'tup-bebek',
    titleKey: 'treat_tup_bebek_title',
    subtitleKey: 'treat_tup_bebek_subtitle',
    descriptionKey: 'treat_tup_bebek_desc',
    tagKey: 'treat_tup_bebek_tag',
    tagColor: '',
    icon: 'ri-parent-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20IVF%20fertility%20clinic%20laboratory%20with%20advanced%20embryology%20equipment%2C%20fertility%20specialist%20working%20with%20microscope%2C%20clean%20sterile%20medical%20environment%20with%20warm%20lighting&width=600&height=400&seq=treat-ivf-1&orientation=landscape',
    color: 'from-emerald-500 to-green-500',
    bg: 'from-emerald-50 to-green-50',
    border: 'border-emerald-100',
    serviceKeys: ['Tüp Bebek (IVF)', 'Genetik Test (PGT)', 'Detaylı Ultrason', 'Doğum Paketi'],
  },
  {
    id: 'kardiyoloji',
    titleKey: 'treat_kardiyoloji_title',
    subtitleKey: 'treat_kardiyoloji_subtitle',
    descriptionKey: 'treat_kardiyoloji_desc',
    tagKey: 'treat_kardiyoloji_tag',
    tagColor: '',
    icon: 'ri-heart-3-line',
    image: 'https://readdy.ai/api/search-image?query=advanced%20cardiology%20hospital%20with%20cardiac%20catheterization%20laboratory%2C%20cardiologist%20reviewing%20heart%20scan%20results%2C%20modern%20medical%20imaging%20equipment%2C%20professional%20cardiovascular%20center&width=600&height=400&seq=treat-cardio-1&orientation=landscape',
    color: 'from-red-500 to-rose-500',
    bg: 'from-red-50 to-rose-50',
    border: 'border-red-100',
    serviceKeys: ['Kardiyoloji', 'Kalp Damar Cerrahisi'],
  },
  {
    id: 'onkoloji',
    titleKey: 'treat_onkoloji_title',
    subtitleKey: 'treat_onkoloji_subtitle',
    descriptionKey: 'treat_onkoloji_desc',
    tagKey: 'treat_onkoloji_tag',
    tagColor: '',
    icon: 'ri-microscope-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20oncology%20treatment%20center%20with%20radiation%20therapy%20equipment%2C%20oncologist%20consulting%20with%20patient%2C%20advanced%20cancer%20treatment%20facility%20with%20warm%20supportive%20environment&width=600&height=400&seq=treat-onco-1&orientation=landscape',
    color: 'from-indigo-500 to-blue-500',
    bg: 'from-indigo-50 to-blue-50',
    border: 'border-indigo-100',
    serviceKeys: ['Onkoloji & Kanser Tedavisi'],
  },
  {
    id: 'obezite',
    titleKey: 'treat_obezite_title',
    subtitleKey: 'treat_obezite_subtitle',
    descriptionKey: 'treat_obezite_desc',
    tagKey: 'treat_obezite_tag',
    tagColor: '',
    icon: 'ri-heart-add-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20bariatric%20surgery%20center%20with%20advanced%20laparoscopic%20equipment%2C%20metabolic%20surgery%20specialist%20consultation%20room%2C%20clean%20professional%20medical%20facility%20with%20supportive%20environment&width=600&height=400&seq=treat-obesity-1&orientation=landscape',
    color: 'from-orange-500 to-amber-500',
    bg: 'from-orange-50 to-amber-50',
    border: 'border-orange-100',
    serviceKeys: ['Obezite & Metabolik Cerrahi'],
  },
  {
    id: 'check-up',
    titleKey: 'treat_checkup_title',
    subtitleKey: 'treat_checkup_subtitle',
    descriptionKey: 'treat_checkup_desc',
    tagKey: 'treat_checkup_tag',
    tagColor: '',
    icon: 'ri-stethoscope-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20health%20check-up%20center%20with%20comprehensive%20diagnostic%20equipment%2C%20doctor%20reviewing%20patient%20health%20screening%20results%2C%20bright%20professional%20medical%20facility%20with%20welcoming%20atmosphere&width=600&height=400&seq=treat-checkup-1&orientation=landscape',
    color: 'from-cyan-500 to-teal-500',
    bg: 'from-cyan-50 to-teal-50',
    border: 'border-cyan-100',
    serviceKeys: ['Check-up & Sağlık Taraması'],
  },
  {
    id: 'noroloji',
    titleKey: 'treat_noroloji_title',
    subtitleKey: 'treat_noroloji_subtitle',
    descriptionKey: 'treat_noroloji_desc',
    tagKey: 'treat_noroloji_tag',
    tagColor: '',
    icon: 'ri-brain-line',
    image: 'https://readdy.ai/api/search-image?query=advanced%20neurology%20and%20brain%20surgery%20center%20with%20MRI%20equipment%2C%20neurosurgeon%20reviewing%20brain%20scan%2C%20modern%20medical%20facility%20with%20high-tech%20diagnostic%20tools&width=600&height=400&seq=treat-neuro-1&orientation=landscape',
    color: 'from-fuchsia-500 to-pink-500',
    bg: 'from-fuchsia-50 to-pink-50',
    border: 'border-fuchsia-100',
    serviceKeys: ['Nöroloji & Beyin Cerrahisi'],
  },
  {
    id: 'uroloji',
    titleKey: 'treat_uroloji_title',
    subtitleKey: 'treat_uroloji_subtitle',
    descriptionKey: 'treat_uroloji_desc',
    tagKey: 'treat_uroloji_tag',
    tagColor: '',
    icon: 'ri-test-tube-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20urology%20clinic%20with%20advanced%20endoscopic%20equipment%2C%20urologist%20consultation%20room%2C%20clean%20professional%20medical%20environment%20with%20specialized%20diagnostic%20tools&width=600&height=400&seq=treat-uro-1&orientation=landscape',
    color: 'from-lime-500 to-green-500',
    bg: 'from-lime-50 to-green-50',
    border: 'border-lime-100',
    serviceKeys: ['Üroloji'],
  },
  {
    id: 'dermatoloji',
    titleKey: 'treat_dermatoloji_title',
    subtitleKey: 'treat_dermatoloji_subtitle',
    descriptionKey: 'treat_dermatoloji_desc',
    tagKey: 'treat_dermatoloji_tag',
    tagColor: '',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20dermatology%20clinic%20with%20laser%20treatment%20equipment%2C%20dermatologist%20examining%20patient%20skin%2C%20bright%20clean%20medical%20environment%20with%20advanced%20skin%20care%20technology&width=600&height=400&seq=treat-derm-1&orientation=landscape',
    color: 'from-yellow-500 to-amber-500',
    bg: 'from-yellow-50 to-amber-50',
    border: 'border-yellow-100',
    serviceKeys: ['Dermatoloji'],
  },
  {
    id: 'fizik-tedavi',
    titleKey: 'treat_fizik_tedavi_title',
    subtitleKey: 'treat_fizik_tedavi_subtitle',
    descriptionKey: 'treat_fizik_tedavi_desc',
    tagKey: 'treat_fizik_tedavi_tag',
    tagColor: '',
    icon: 'ri-run-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20physical%20therapy%20rehabilitation%20center%20with%20exercise%20equipment%2C%20physiotherapist%20working%20with%20patient%2C%20bright%20supportive%20medical%20environment%20with%20recovery%20facilities&width=600&height=400&seq=treat-physio-1&orientation=landscape',
    color: 'from-teal-500 to-cyan-500',
    bg: 'from-teal-50 to-cyan-50',
    border: 'border-teal-100',
    serviceKeys: ['Fizik Tedavi & Rehabilitasyon'],
  },
  {
    id: 'organ-nakli',
    titleKey: 'treat_organ_nakli_title',
    subtitleKey: 'treat_organ_nakli_subtitle',
    descriptionKey: 'treat_organ_nakli_desc',
    tagKey: 'treat_organ_nakli_tag',
    tagColor: '',
    icon: 'ri-heart-2-line',
    image: 'https://readdy.ai/api/search-image?query=advanced%20organ%20transplant%20surgery%20center%20with%20specialized%20medical%20team%2C%20transplant%20surgeon%20in%20operating%20room%2C%20high-tech%20medical%20facility%20with%20life-saving%20equipment&width=600&height=400&seq=treat-organ-1&orientation=landscape',
    color: 'from-red-500 to-orange-500',
    bg: 'from-red-50 to-orange-50',
    border: 'border-red-100',
    serviceKeys: ['Organ Nakli'],
  },
];
